
<script>
    const data = [
        {
            img: '/images/testis/Anya Cheng, FOE 07, Taelor.jpg',

            title: 'Anya Cheng',
            year_startup: 'FOE 2021 | Taelor',
            description:
                '<p style=\'margin-bottom: 1.05vw\'>🏆I’m so honored to have pitched to Tim Draper and'+
                ' receive the first place award in the Draper University entrepreneurship competition!'+
                ' And, on the same day, Rent The Runway just filed for an #IPO🦄 !</p><p style=\'margin-bottom:1.05vw\'>'+
                'I’m so excited that people are starting to believe in the #sustainability ♻️ and #circulareconomy'+
                ' #circularfashion 🌎space.</P><p style=\'margin-bottom:1.05vw\'>Can’t wait to learn more from Tim'+
                ' and grow my startup, so that more people can achieve their goal and save the environment</p>',
        },
        {
            img: '/images/testis/Dario Franco, Summer 2021, Clan Esports Academy.jpg',
            title: 'Dario Franco',
            year_startup: 'Summer 2021 | Clan Esports Academy',
            description:
                ' <p style=\'margin-bottom:1.25vw\'> CLAN eSports Academy was my own bet, but after spending'+
                ' these months in Draper University\'s accelerator program in Silicon Valley everything changed.</p>'+
                '<p style=\'margin-bottom:1.05vw\'> Now it\'s no longer a bet, it\'s a reality. A reality of many people.'+
                ' Thanks to Asra N., Tim Draper,Andrew Tang, and the whole DUV team, we were able to make this a'+
                ' real company. Today we can say that Clan is part of DraperU Ventures portfolio.</p>'+
                '<p style=\'margin-bottom:0.5vw\'>Day by day I reinforce my philosophy of facing my biggest fears.'+
                ' Talking to strangers. Meeting people.Getting away from comfort. Transforming my passions into '+
                'my business. And turn my life into the best f***ing crazy story in the world.</p>'+
                '<p style=\'margin-bottom:1.05vw\'>This is the beginning of CLAN, get in quick we\'releaving!</p>',
        },
        {
            img: '/images/testis/Rumaisa Mughal, Fall 2014, Change Reactor.jpg',
            title: 'Rumaisa Mughal',
            year_startup: 'Fall 2014 | Change Reactor',
            description:
                ' <p style=\'margin-bottom:1.05vw\'> Draper University of Heroes appears to have more in common with'+
                ' Harry Potter’s Hogwarts than it does with anything seen in traditional education.</p>'+
                '<p style=\'margin-bottom:1.05vw\'> Its system, outlook, curriculum, policies, staff, and'+
                ' culture — all of it is unorthodox and proud to be so. </p>'+
                '<p style=\'margin-bottom:1.05vw\'>During the program we got the opportunity to visit amazing places'+
                ' and meet real world heroes; innovators, thinkers, geniuses and more who are contributing'+
                ' to the future of this planet.</p>',
        },
        {
            img: '/images/testis/Dhruv Washishth, Winter 2016, Paradigm Shift Capital.jpg',
            title: 'Dhruv Washishth',
            year_startup: 'Winter 2016 | Paradigm Shift Capital',
            description:
                ' <p style=\'margin-bottom:1.05vw\'> Draper University is a blend of an alternative'+
                ' education program & an entrepreneurship accelerator! Run by Billionaire venture capitalist'+
                ' - Tim Draper, it attracts entrepreneurs from across the globe! You get to spend 2 months '+
                'with bright, eager minds from so many different countries, cultures and backgrounds! '+
                '(My batch had 45 people from 20 countries)</p><p style=\'margin-bottom:1.05vw\'>'+
                'This mix of people assembled in the heart of Silicon Valley is quite the formula for magic.'+
                ' You feel a rush of excitement everyday and the staff and mentors push you out of your '+
                'comfort zone quite literally!</p><p style=\'margin-bottom:1.05vw\'>You get to hear from speakers'+
                ' like Elon Musk to Biz Stone & also from entrepreneurs who have failed!</p>',
        },
        {
            img: '/images/testis/Daisy Burns, Summer 2021, UNH Change Maker Collaborative.jpg',
            title: 'Daisy Burns',
            year_startup: 'Summer 2021 | UNH Changemaker',
            description:
                ' <p style=\'margin-bottom:1.05vw\'>This summer I had the opportunity to attend Draper University '+
                'Hero Training for entrepreneurship. </p><p style=\'margin-bottom:1.05vw\'>This program included '+
                'sessions with founders in various industries, an AI and decentralization hackathon, a tour of '+
                'silicon valley, survival week, a leadership workshop with Gina Kloes, and pitching to 120+'+
                ' investors on Demo Day.</p><p style=\'margin-bottom:1.05vw\'>In addition to teaching me how to'+
                ' build a successful business, being at Draper gave me the chance to connect and learn '+
                'from over 80 other entrepreneurs from around the world.</p>'+
                ' <p style=\'margin-bottom:1.05vw\'>The enthusiasm and motivation of'+
                ' these students was very inspiring </p>',
        },
        {
            img: '/images/testis/Tam Pham, Fall 2015, MMT Commmunity.jpg',
            title: 'Tam Pham',
            year_startup: 'Fall 2015 | MMT Community',
            description:
                ' <p style=\'margin-bottom:1.05vw\'> I wanted to think BIGGER. </p>'+
                '<p style=\'margin-bottom:1.05vw\'> In DU, everyone will encourage you to think 10x. Meaning… '+
                'instead of making a company that makes a 10% improvement over the competition, what if you '+
                'can make a 10x improvement?</p><p style=\'margin-bottom:1.05vw\'>Instead of giving people faster'+
                ' horses… you create a car instead. How can we use this 10x mindset to'+
                ' disrupt existing industries?</p>',
        },
        {
            img: '/images/testis/Olu Ogunlela, Summer 2021, LifeRithms.jpg',
            title: 'Olu Ogunlela',
            year_startup: 'Summer 2021 | Life Rithms',
            description:
                ' <p  style="margin-bottom:1.05vw"> Draper University was a once-in-a-lifetime experience.'+
                ' If you put the startup sessions aside, it was a startup founder mindset training boot camp. '+
                'It changes my perspective about what I thought was possible.</p><p style="margin-bottom:1.05vw">'+
                'I am thankful to Tim Draper, Andrew Tang, Asra N., Daniela Quintero, Suffiyan Malik, and the rest '+
                'of the DraperU team.</p><p style="margin-bottom:1.05vw">Also grateful to be paired with my awesome'+
                ' Team Wonders teams. Together we are unstoppable.</p> <p style="margin-bottom:1.05vw">Loads of First '+
                'Experiences. We are ready to build billion-dollar companies.</p> <p style="margin-bottom:1.05vw">'+
                '"I will fail and fail again until I succeed" - Draper University Startup Hero Pledge</p>',
        },
        {
            img: '/images/testis/Shermaine Wong, FOE 08, Cult Creative.jpg',
            title: 'Shermaine Wong',
            year_startup: 'FOE 08 | Cult Creative',
            description:
                ' <p style=\'margin-bottom:1.05vw\'> Enriching and insightful two weeks - FOE </p>'+
                '<p style=\'margin-bottom:1.05vw\'>The most friendly and engaging community of instructors, '+
                    'experts and startup founders, I\'ve had the pleasure to learn, fail, thrive and grow together '+
                    'with from all parts of the globe. </p><p style=\'margin-bottom:1.05vw\'>Thank you and I look '+
                        'forward to crossing paths again!</p>',
        },
        {
            img: '/images/testis/Munir Usman, Fall 2013, CodeInterview.io.jpg',
            title: 'Munir Usman',
            year_startup: 'Fall 2013 | CodelInterview.io',
            description:
                ' <p style=\'margin-bottom:1.05vw\'> I attended Draper University in 2013 and it was'+
                ' a life-changing experience for me.</p><p style=\'margin-bottom:1.05vw\'>I had been in '+
                'the software business for many years but at DraperU I learnt how to create real impact in '+
                'the world with my business. I learnt how to aim high and take bigger risks in life. I learnt'+
                ' to accept that failures are part of a successful journey. I learnt that real innovation is not '+
                'about making things a little bit more efficient. Innovation is about disrupting existing ways'+
                ' and building things that are at least 10x better.</p><p style=\'margin-bottom:1.05vw\'>You will'+
                ' also build a very strong network with professionals in the Bay Area and a personal network'+
                ' with DraperU alumni. And if you are lucky like me, you will also find your spouse here'+
                ' because I just married my dream woman who I met through DU alumni network</p>',
        },
    ];
    const dataMbl = [
        {
            img: '/images/testis/Anya Cheng, FOE 07, Taelor.jpg',
            title: 'Anya Cheng',
            year_startup: 'FOE 2021 | Taelor',
            description:
            '<p style=\'bottom:0.5vw\'>🏆I’m so honored to have pitched to Tim Draper and receive '+
            'the first place award in the Draper University entrepreneurship competition! And, on the'+
            ' same day, Rent The Runway just filed for an #IPO🦄 !</p><p style=\'bottom:0.5vw\'>'+
            'I’m so excited that people are starting to believe in the #sustainability ♻️ and'+
            ' #circulareconomy #circularfashion 🌎space.</P><p style=\'bottom:0.5vw\'>Can’t wait to learn more '+
            'from Tim and grow my startup, so that more people can achieve their goal and save the environment</p>',
        },
        {
            img: '/images/testis/Dario Franco, Summer 2021, Clan Esports Academy.jpg',
            title: 'Dario Franco',
            year_startup: 'Summer 2021 | Clan Esports Academy',
            description:
            ' <p style=\'bottom:0.5vw\'> CLAN eSports Academy was my own bet, but after spending '+
            'these months in Draper University\'s accelerator program in Silicon Valley everything changed.</p>'+
            '<p style=\'bottom:0.5vw\'> Now it\'s no longer a bet, it\'s a reality. A reality of '+
            'many people. Thanks to Asra N., Tim Draper,Andrew Tang, and the whole DUV team,'+
            ' we were able to make this a real company. Today we can say that Clan is part of DraperU Ventures '+
            'portfolio.</p><p style=\'bottom:0.5vw\'>Day by day I reinforce my philosophy of facing my biggest fears.'+
            ' Talking to strangers. Meeting people.Getting away from comfort. Transforming my passions into my business. '+
            'And turn my life into the best f***ing crazy story in the world.</p><p style=\'bottom:0.5vw\'>'+
            'This is the beginning of CLAN, get in quick we\'releaving!</p>',
        },
        {
            img: '/images/testis/Rumaisa Mughal, Fall 2014, Change Reactor.jpg',
            title: 'Rumaisa Mughal',
            year_startup: 'Fall 2014 | Change Reactor',
            description:
                ' <p style=\'bottom:0.5vw\'> Draper University of Heroes appears to have more in common'+
                ' with Harry Potter’s Hogwarts than it does with anything seen in traditional education.</p>'+
                '<p style=\'bottom:0.5vw\'> Its system, outlook, curriculum, policies, staff, and '+
                'culture — all of it is unorthodox and proud to be so. </p><p style=\'bottom:0.5vw\'>'+
                'During the program we got the opportunity to visit amazing places and meet real world heroes; '+
                'innovators, thinkers, geniuses and more who are contributing to the future of this planet.</p>',
        },
        {
            img: '/images/testis/Dhruv Washishth, Winter 2016, Paradigm Shift Capital.jpg',
            title: 'Dhruv Washishth',
            year_startup: 'Winter 2016 | Paradigm Shift Capital',
            description:
                ' <p style=\'bottom:0.5vw\'> Draper University is a blend of an alternative education'+
                ' program & an entrepreneurship accelerator! Run by Billionaire venture capitalist - Tim Draper,'+
                ' it attracts entrepreneurs from across the globe! You get to spend 2 months with '+
                'bright, eager minds from so many different countries, cultures and backgrounds! '+
                '(My batch had 45 people from 20 countries)</p><p style=\'bottom:0.5vw\'>This mix of people assembled in t'+
                'he heart of Silicon Valley is quite the formula for magic. You feel a rush of excitement everyday and the'+
                ' staff and mentors push you out of your comfort zone quite literally!</p><p style=\'bottom:0.5vw\'>You'+
                ' get to hear from speakers like Elon Musk to Biz Stone & also from entrepreneurs who have failed!</p>',
        },
        {
            img: '/images/testis/Daisy Burns, Summer 2021, UNH Change Maker Collaborative.jpg',
            title: 'Daisy Burns',
            year_startup: 'Summer 2021 | UNH Changemaker',
            description:
                ' <p style=\'bottom:0.5vw\'>This summer I had the opportunity to attend Draper University '+
                'Hero Training for entrepreneurship. </p><p style=\'bottom:0.5vw\'>This program included sessions'+
                ' with founders in various industries, an AI and decentralization hackathon, a'+
                ' tour of silicon valley, survival week, a leadership workshop with Gina Kloes, '+
                'and pitching to 120+ investors on Demo Day.</p><p style=\'bottom:0.5vw\'>In addition to teaching me'+
                ' how to build a successful business, being at Draper gave me the chance to connect and learn from'+
                ' over 80 other entrepreneurs from around the world.</p> <p style=\'bottom:0.5vw\'>The enthusiasm and'+
                ' motivation of these students was very inspiring </p>',
        },
        {
            img: '/images/testis/Tam Pham, Fall 2015, MMT Commmunity.jpg',
            title: 'Tam Pham',
            year_startup: 'Fall 2015 | MMT Community',
            description:
                ' <p style=\'bottom:0.5vw\'> I wanted to think BIGGER. </p><p style=\'bottom:0.5vw\'>'+
                ' In DU, everyone will encourage you to think 10x. Meaning… instead of making a company that makes'+
                ' a 10% improvement over the competition, what if you can make a 10x improvement?</p>'+
                '<p style=\'bottom:0.5vw\'>Instead of giving people faster horses… you create a car '+
                'instead. How can we use this 10x mindset to disrupt existing industries?</p>',
        },
        {
            img: '/images/testis/Olu Ogunlela, Summer 2021, LifeRithms.jpg',
            title: 'Olu Ogunlela',
            year_startup: 'Summer 2021 | Life Rithms',
            description:
                ' <p  style="bottom:0.5vw"> Draper University was a once-in-a-lifetime experience. If'+
                ' you put the startup sessions aside, it was a startup founder mindset training boot camp. '+
                'It changes my perspective about what I thought was possible.</p><p style="bottom:0.5vw">'+
                'I am thankful to Tim Draper, Andrew Tang, Asra N., Daniela Quintero, Suffiyan '+
                'Malik, and the rest of the DraperU team.</p><p style="bottom:0.5vw">Also grateful to be'+
                ' paired with my awesome Team Wonders teams. Together we are unstoppable.</p> '+
                '<p style="bottom:0.5vw">Loads of First Experiences. We are ready to build billion-dollar'+
                ' companies.</p> <p style="bottom:0.5vw">"I will fail and fail again until I succeed" - Draper'+
                ' University Startup Hero Pledge</p>',
        },
        {
            img: '/images/testis/Shermaine Wong, FOE 08, Cult Creative.jpg',
            title: 'Shermaine Wong',
            year_startup: 'FOE 08 | Cult Creative',
            description:
                ' <p style=\'bottom:0.5vw\'> Enriching and insightful two weeks - FOE </p>'+
            '<p style=\'bottom:0.5vw\'>The most friendly and engaging community of instructors, experts and '+
                'startup founders, I\'ve had the pleasure to learn, fail, thrive and grow together with '+
                'from all parts of the globe. </p><p style=\'bottom:0.5vw\'>Thank you and I look '+
            'forward to crossing paths again!</p>',
        },
        {
            img: '/images/testis/Munir Usman, Fall 2013, CodeInterview.io.jpg',
            title: 'Munir Usman',
            year_startup: 'Fall 2013 | CodelInterview.io',
            description:
            ' <p style=\'bottom:0.5vw\'> I attended Draper University in 2013 and it was a '+
            'life-changing experience for me.</p><p style=\'bottom:0.5vw\'>I had been in the software '+
            'business for many years but at DraperU I learnt how to create real impact in the world'+
            ' with my business. I learnt how to aim high and take bigger risks in life. I learnt to '+
            'accept that failures are part of a successful journey. I learnt that real innovation is not about'+
            ' making things a little bit more efficient. Innovation is about disrupting existing ways and building'+
            ' things that are at least 10x better.</p><p style=\'margin-bottom:0.5vw\'>You will also build a very '+
            'strong network with professionals in the Bay Area and a personal network with DraperU alumni. And if '+
            'you are lucky like me, you will also find your spouse here because I just married my dream woman who '+
            'I met through DU alumni network</p>',
        },
    ];
    const user = {view_all: false};
    /**
     *
     */
    function toggle() {
        user.view_all = !user.view_all;
    }
</script>

<div class="desktop">
    <div class="container-fluid background">
        <h1 class="maintitle">Alumni Reviews</h1>
        <p class="maintext">
            Our heroes go off and do amazing things and pursue life with gusto
            and enthusiasm.
        </p>
        <div class="col-md-12 col-xl-12" style="padding-bottom: 4vw;">
            <div style="width: 72.09vw; margin:auto;">
                <div class="row" style="margin-top: 2.125vw;">
                    {#each data as data}
                        <div class="col-md-4 .col-xl-4">
                            <div class="align">
                                <div class="img-wrapper center">
                                    <img
                                        class="desktop-img"
                                        src={data.img}
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <h3 class="pre-title">{data.title}</h3>
                                <h4 class="year-and-startup">
                                    {data.year_startup}
                                </h4>
                                <div class="pre-text">
                                    <p>
                                        {@html data.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>
<!---Mobile Design--->
<div class="mobile">
    <div class="container-fluid background-mbl">
        <p class="maintitle">Alumni Reviews</p>
        <p class="maintext">
            Our heroes go off and do amazing things and pursue life with gusto
            and enthusiasm.
        </p>
        <div
            class="div-css {user.view_all ? 'view-all' : 'view-less'}"
        >
            {#each dataMbl as data}
                <div class="back-div">
                    <div class="pre-text-mbl">
                        {@html data.description}
                    </div>
                    <div class="triangle-topleft" />
                    <div class="face-img">
                        <img
                            src={data.img}
                            alt=""
                            width="100%"
                            style="border-radius: 50%;"
                        />
                    </div>
                    <p class="name-title">{data.title}</p>
                    <p class="year-and-startup-mbl">{data.year_startup}</p>
                </div>
            {/each}
        </div>
        {#if !user.view_all}
            <button class="view-all-btn " on:click={toggle}>
                <p class="view-text ">View All</p>
                <div class="arrow-down" />
            </button>
        {/if}
        {#if user.view_all}
            <button class="view-all-btn  " on:click={toggle}>
                <p class="view-text ">View Less</p>
                <div class="arrow-up" />
            </button>
        {/if}
    </div>
</div>

<style>
    .maintitle {
        font-family: Manrope;
        font-size: 2.646vw;
        font-weight: 500;
        line-height: 2.737vw;
        text-align: center;
        padding-top: 3.918vw;
        color: #00204b;
    }
    .maintext {
        font-family: Manrope;
        font-size: 0.926vw;
        font-weight: 500;
        line-height: 1.04vw;
        letter-spacing: 0em;
        text-align: center;
        margin-top: 0.863vw;
        color: #000000;
        width: 100%;
    }
    .year-and-startup {
        text-align: center;
        font-size: 0.529vw;
        font-weight: 400;
        line-height: 0.604167vw;
        margin-top: 0.661vw;
    }
    .background {
        background-repeat: no-repeat;
        background-size: cover;
        background-color: aliceblue;
        background-image: url("/images/testis/background.svg");
        margin-top: 7.870vw;
    }
    h3 {
        font-family: Inter;
        font-size: 0.926vw;
        font-weight: 700;
        line-height: 0.93vw;
        letter-spacing: 0em;
        text-align: center;
        color: #00204b;
    }
    .pre-text {
        width: 17.857vw;
        font-size: 0.794vw;
        font-weight: 400;
        line-height: 0.952vw;
        margin: auto;
        color: #00204b;
        margin-top: 0.992vw;
        margin-bottom: 0.5vw !important;
    }
    .center {
        text-align: center;
        padding-top: 0.909vw;
    }
    .pre-title {
        text-align: center;
        padding-top: 0.598vw;
    }
    .desktop-img {
        height: 3.046vw;
        width: 3.054vw;
        border-radius: 100%;
        align-items: center;
    }
    .align {
        box-shadow: 0vw 0.2vw 0.4vw rgb(0 0 0 / 25%);
        border-radius: 2vw;
        background: #ffffff;
        position: relative;
        width: 21.164vw;
        color: #00204b;
        height: 29.762vw;
        margin-top: 2.457vw;
    }
    .background-mbl {
        background-color: #eff8ff;
        padding: 18.224vw;
    }
    .pre-text-mbl {
        font-size: 2.5vw;
        font-weight: 400;
        line-height: 2.962vw;
        padding: 3vw;
    }
    .face-img {
        width: 14.019vw;
        height: 14.019vw;
        position: absolute;
        left: 1.364vw;
        bottom: -20vw;
    }
    .name-title {
        font-size: 3.271vw;
        font-weight: bold;
        font-family: Inter;
        color: #00204b;
        position: absolute;
        bottom: -17vw;
        left: 20vw;
    }
    .year-and-startup-mbl {
        color: #00204b;
        font-size: 1.98vw;
        position: absolute;
        left: 20vw;
        bottom: -21vw;
    }
    .back-div {
        background-color: #ffffff;
        width: 55.841vw;
        position: relative;
        border-radius: 4vw;
        margin-left: 4vw;
        margin-top: 11vw;
        margin-bottom: 28vw;
    }

    .triangle-topleft {
        width: 0;
        height: 0;
        border-top: 17.523vw solid #ffffff;
        border-right: 13.019vw solid transparent;
        position: absolute;
        left: 10vw;
        bottom: -17vw;
    }
    .arrow-down {
        border: solid #00204b;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 1.1vw;
        transform: rotate(45deg);
        margin-left: 4.636vw;
        box-sizing: border-box;
    }
    .arrow-up {
        border: solid #00204b;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 1.1vw;
        transform: rotate(224deg);
        margin-left: 4.636vw;
        box-sizing: border-box;
        margin-top: 1vw;
    }
    .view-all-btn {
        display: flex;
        border: none;
        background-color: transparent;
        margin: auto;
        border-bottom: 1px solid #00204b;
    }
    .view-all {
        height: 830vw;
    }
    .view-less {
        height: 195vw;
    }
    .view-text {
        color: #00204b;
        font-size: 3.271vw;
        font-weight: 400;
        margin-bottom: 0;
    }
    .div-css {
        overflow: hidden;
    }
    .div-css::-webkit-scrollbar {
        display: none;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
        .maintitle {
            font-size: 5.607vw;
            font-weight: 800;
        }
        .maintext {
            font-size: 2.636vw;
            line-height: 4.192vw;
            margin-top: 2.8vw;
        }
    }
</style>
